import axios, { AxiosRequestTransformer } from 'axios';
import { Store } from '@reduxjs/toolkit';
import moment from 'moment-timezone';
import {setServerError} from "./state";

const dateTransformer = (data: any): any => {
    if (data instanceof Date) {
        return moment(data).format('YYYY-MM-DDTHH:mm:ss')
    }
    if (Array.isArray(data)) {
        return data.map(dateTransformer)
    }
    if (typeof data === 'object' && data !== null) {
        return Object.fromEntries(Object.entries(data).map(([key, value]) => [key, dateTransformer(value)]))
    }
    return data
}

export function configureAxiosDefaults(store: Store) {
    axios.defaults.headers.common['Content-Type'] = 'application/json';
    axios.defaults.headers.common['Accept'] = 'application/json';
    axios.defaults.baseURL = '/api';

    axios.defaults.transformRequest = [dateTransformer, ...(axios.defaults.transformRequest as AxiosRequestTransformer[])];
    axios.interceptors.response.use(response => response, error => {
        var errorResponse = error;
        if (error.response) {
            if (error.response.data) {
                errorResponse = error.response.data;
            }

            if (error?.response?.status >= 500) {
                store.dispatch(setServerError({
                    title: 'Server Error',
                    message: 'Something went wrong. Please try again later.',
                    raw: error,
            }));

        }

        return Promise.reject(errorResponse);
    }

})}
